import React from 'react'
import { Button, Modal } from 'stylist'

const DeleteGroupModal = ({ group, open, onDelete, onClose }) => (
  <Modal open={open} onClose={onClose}>
    <Modal.Header>
      <Modal.Title>Delete group</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Are you sure you want to delete the group <em>{group.name}</em>? By
      performing this action, you will disable all features for all users in
      this group.
    </Modal.Body>
    <Modal.Footer>
      <Modal.CancelButton />
      <Button kind="danger" onClick={onDelete}>
        Delete group
      </Button>
    </Modal.Footer>
  </Modal>
)

export default DeleteGroupModal



// WEBPACK FOOTER //
// ./src/routes/admin/features/groups/components/DeleteGroupModal.js